import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import md5 from 'md5';
import { ACTIONS } from '../../actions/actionTypes';

import SheetView from './questionSheetView';
import TestView from './questionTestView';
import CorrectionView from './questionCorrectionView';
import AffirmationView from './questionAffirmationView';
import AffirmationCorrectionView from './affirmationCorrectionView';
import errorCatcher from '../../utils/errorCatcher';

class Questions extends Component {
    constructor (props) {
        super(props);
        this.state = {
            session: {
                answers: [],
                totalQuestionsCount: 0,
                timeSpent: 0
            },
            timeToAnswer: 0,
            isSessionFinished: false
        };
    }

    componentDidMount () {
        this.props.resetTimer();
    }

    componentWillReceiveProps (nextProps) {
        if (this.state.isSessionFinished === false) {
            if (this.shouldFinishSession()) {
                this.stopSession('PAPER');
            }
        }

        if (nextProps.questions && nextProps.questions.length !== this.state.session.totalQuestionsCount) {
            this.setQuestionsQtt(nextProps.questions.length);
        }
    }

    shouldFinishSession = (currentQuestion) => {
        // No need to finish a session already finished
        if (this.state.isSessionFinished === true) {
            return false;
        }

        // When there's no time left
        const timeSpent = this.props.timer.time;
        const timeToAnswer = this.state.timeToAnswer;
        if (timeSpent > timeToAnswer) {
            return true;
        }

        // When there's no questions left
        const questionsQtt = this.state.session.totalQuestionsCount;
        let finish = (currentQuestion && currentQuestion === (questionsQtt - 1));
        return finish;
    };

    stopSession = (viewType) => {
        this.setState({isSessionFinished: true});
        this.props.stopTimer();
        let session = this.state.session;
        session.timeSpent = this.props.timer.time;
        this.props.resetTimer();
        this.props.finishSession(session, viewType);
    };

    showModalAndStopTimer = (text, videoLink, curiosityLink) => {
        this.props.stopTimer();
        this.props.modalOpen(text, videoLink, curiosityLink, () => {
            this.props.startTimer();
        });
    };

    setQuestionsQtt = (questionsQtt) => {
        let timeToAnswer = Math.ceil(questionsQtt / 2) * 60;
        let session = this.state.session;
        session.totalQuestionsCount = questionsQtt;
        this.setState({timeToAnswer, session});
    };

    addAnswerToSession = (answer) => {
        let session = this.state.session;
        session.answers.push(answer);
        this.setState({session});
    };

    sendAllCorrect = () => {
        const answers = this.props.questions.map(question => {
            const correct = question.options.find(option => this.isCorrect(option));
            return {
                question: question.id,
                option: correct.id
            };
        });
        const session = {
            answers,
            timeSpent: 0,
            totalQuestionsCount: answers.length
        };
        this.props.finishSession(session);
    };

    sendAllWrong = () => {
        const answers = this.props.questions.map(question => {
            const correct = question.options.find(option => !this.isCorrect(option));
            return {
                question: question.id,
                option: correct.id
            };
        });
        const session = {
            answers,
            timeSpent: 0,
            totalQuestionsCount: answers.length
        };
        this.props.finishSession(session);
    };

    isCorrect = (option) => {
        return md5('~' + option._id + '~') === option.hash;
    };

    render () {
        const questionView = this.props.questionView || '';
    switch (questionView.toUpperCase()) {
        case 'SHEET':
            return <SheetView
                {...this.props}
                shouldFinishSession={(currentQuestion) => this.shouldFinishSession(currentQuestion)}
                stopSession={() => this.stopSession('SHEET')}
                showModalAndStopTimer={(text, videoLink, curiosityLink) => this.showModalAndStopTimer(text, videoLink, curiosityLink)}
                addAnswerToSession={(answer) => this.addAnswerToSession(answer)}
                sendAllCorrect={this.sendAllCorrect}
                sendAllWrong={this.sendAllWrong}
                isCorrect={this.isCorrect}
            />;

        case 'PAPER':
            return <TestView
                {...this.props}
                shouldFinishSession={(currentQuestion) => this.shouldFinishSession(currentQuestion)}
                stopSession={() => this.stopSession('PAPER')}
                showModalAndStopTimer={(text, videoLink, curiosityLink) => this.showModalAndStopTimer(text, videoLink, curiosityLink)}
                addAnswerToSession={(answer) => this.addAnswerToSession(answer)}
                sendAllCorrect={this.sendAllCorrect}
                sendAllWrong={this.sendAllWrong}
                isCorrect={this.isCorrect}
            />;

        case 'CORRECTION':
            return <CorrectionView
                {...this.props}
                shouldFinishSession={(currentQuestion) => this.shouldFinishSession(currentQuestion)}
                stopSession={() => this.stopSession('CORRECTION')}
                showModalAndStopTimer={(text, videoLink, curiosityLink) => this.showModalAndStopTimer(text, videoLink, curiosityLink)}
                addAnswerToSession={(answer) => this.addAnswerToSession(answer)}
                sendAllCorrect={this.sendAllCorrect}
                sendAllWrong={this.sendAllWrong}
                isCorrect={this.isCorrect}
            />;

        case 'AFFIRMATION':
            return <AffirmationView
                {...this.props}
                shouldFinishSession={(currentQuestion) => this.shouldFinishSession(currentQuestion)}
                stopSession={() => this.stopSession('AFFIRMATION')}
                showModalAndStopTimer={(text, videoLink, curiosityLink) => this.showModalAndStopTimer(text, videoLink, curiosityLink)}
                addAnswerToSession={(answer) => this.addAnswerToSession(answer)}
                sendAllCorrect={this.sendAllCorrect}
                sendAllWrong={this.sendAllWrong}
                isCorrect={this.isCorrect}
            />;

        case 'AFFIRMATIONCORRECTION':
            return <AffirmationCorrectionView
                {...this.props}
                shouldFinishSession={(currentQuestion) => this.shouldFinishSession(currentQuestion)}
                stopSession={() => this.stopSession('AFFIRMATION_CORRECTION')}
                showModalAndStopTimer={(text, videoLink, curiosityLink) => this.showModalAndStopTimer(text, videoLink, curiosityLink)}
                addAnswerToSession={(answer) => this.addAnswerToSession(answer)}
                sendAllCorrect={this.sendAllCorrect}
                sendAllWrong={this.sendAllWrong}
                isCorrect={this.isCorrect}
            />;

        default:
            errorCatcher(new Error('Invalid question view type'));
            this.props.push('/');
            return null;
        }
    }
}

const mapStateToProps = ({questionReducer, timeReducer}) => {
    const timer = timeReducer;
    const {questionView, questions} = questionReducer;
    return {questionView, questions, timer};
};

const mapActions = (dispatch) => ({
    push: (location) => dispatch(push(location)),
    finishSession: (session, viewType) => dispatch({
        type: ACTIONS.FINISH_SESSION,
        payload: {session, viewType}
    }),
    modalOpen: (text, youtubeLink, curiosityLink, callback = () => {
    }) => dispatch({
        type: ACTIONS.OPEN_MODAL,
        payload: {text, youtubeLink, curiosityLink, callback}
    }),
    startTimer: () => dispatch({
        type: ACTIONS.START_TIMER
    }),
    stopTimer: () => dispatch({
        type: ACTIONS.STOP_TIMER
    }),
    resetTimer: () => dispatch({
        type: ACTIONS.RESET_TIMER
    })
});

export default connect(mapStateToProps, mapActions)(Questions);



// WEBPACK FOOTER //
// ./src/views/QuestionsView/questionContainter.js